
const SectionIndex = {
    search: 0,
    shipmentInfo: 1,
    rescheduleReasoning: 2,
    earliestDeliveryDate: 3,
    lastFreeDate: 4,
    appointmentTime: 5,
    contactInfo: 6,
    confirm: 7,
};

const parcelRE = /small parcel [^_]*/i;

var PODetail = function (appointment) {
    var self = this;

    const poDetails = appointment.po;
    let shipmentSize = "";
    let palletNum = 0;

    if (appointment.shipmentSize) {
        shipmentSize = appointment.shipmentSize;
    } else if (poDetails.shipmentSize) {
        shipmentSize = poDetails.shipmentSize;
    }

    palletNum = (shipmentSize.indexOf('LTL') !== -1 || shipmentSize.match(parcelRE) || poDetails.internalPurchaseOrderNumber !== null)
        ? appointment.isScheduled ? appointment.palletCount : poDetails.palletCount
        : shipmentSize.indexOf("20ft Container") !== -1 ? 13 : 26;

    self.AppointmentId = ko.observable(appointment.appointmentId);
    self.POID = ko.observable(poDetails.poid);
    self.TimeZoneDefaultCity = ko.observable(poDetails.timeZoneDefaultCity);
    self.SupplierPONum = ko.observable(poDetails.supplierPONum);
    self.Destination = ko.observable(poDetails.destination);
    self.DestinationID = ko.observable(poDetails.destinationID);
    self.ShipmentSize = ko.observable(shipmentSize);
    self.ShipmentSizeType = ko.observable(poDetails.shipmentSizeType);
    self.TrackingNum = ko.observable(appointment.isScheduled ? appointment.trackingNumber : poDetails.trackingNum);
    self.MasterBillOfLading = ko.observable(appointment.isScheduled ? appointment.masterBillOfLadingNumber : poDetails.masterBillOfLadingNum);
    self.BillOfLading = ko.observable(appointment.isScheduled ? appointment.billOfLadingNumber : poDetails.billOfLadingNum);
    self.CarriersReferenceNumber = ko.observable(appointment.isScheduled ? appointment.carrierProNumber : poDetails.carriersReferenceNum);
    self.ConfirmationNumber = ko.observable(appointment.confirmationNumber);
    self.OriginID = ko.observable(poDetails.originID);
    self.WarehouseEmail = ko.observable(appointment.warehouse ? appointment.warehouse.email : '');
    self.PNCount = ko.observable(appointment.isScheduled ? appointment.pnCount : poDetails.pnCount);
    self.CartonCount = ko.observable(appointment.cartonCount ? appointment.cartonCount : 0);
    self.NewPNCount = ko.observable(appointment.newPNCount);
    self.InternalPurchaseOrder = ko.observable(poDetails.internalPurchaseOrderNumber);
    self.PalletNum = ko.observable(palletNum);
    self.ShippingCo = ko.observable(poDetails.shippingCo);
    self.ContainerNum = ko.observable(poDetails.containerNum);
    self.IsContainer = ko.observable(self.ShipmentSize().indexOf("Container") !== -1);
    self.IsScheduled = ko.observable(appointment.isScheduled);
    self.ScheduledDate = ko.observable(appointment.appointmentDate);
    self.DisplayInternalPurchaseOrder = ko.observable(CanDisplayInternalPurchaseOrder(poDetails.internalPurchaseOrderNumber));
    self.VendorReferenceNumber = ko.observable(appointment.vendorReferenceNumber);
    self.ConfirmationNumber = ko.observable(appointment.confirmationNumber);
    self.IsCustomPalletCountQualified = ko.computed(() => {
        return self.ShipmentSize().indexOf('LTL') !== -1 || self.ShipmentSize().match(parcelRE) || self.InternalPurchaseOrder() !== null;
    })
    self.CanEditPalletNum = ko.computed(() => {
        return self.IsCustomPalletCountQualified() && self.ShipmentSize();
    });

    self.AllowSchedulingAfterLFD = ko.observable(poDetails.allowSchedulingAfterLFD);

    self.PalletAcknowledge = ko.observable(false);
    self.Reschedule = ko.observable(false);
    self.RescheduleReason = ko.observable('');

    self.ShipmentSize.subscribe((newValue) => {
        if (!CustomPalletCountQualified()) {
            self.PalletNum(newValue.indexOf("20ft Container") !== -1 ? 13 : 26);
            self.IsContainer(newValue.indexOf("Container") !== -1);
        }
    });

    function CanDisplayInternalPurchaseOrder(internalPurchaseOrderNumber){
            return internalPurchaseOrderNumber !== null;
        };
    function CustomPalletCountQualified() {
            return self.ShipmentSize().indexOf('LTL') !== -1 || self.ShipmentSize().match(parcelRE) || self.InternalPurchaseOrder() !== null;
        };
};

var SelectedPODetail = function (poDetails) {
    var self = this;

    self.IsScheduled = ko.observable(poDetails.IsScheduled());

    self.AppointmentId = ko.observable(poDetails.AppointmentId());
    self.POID = ko.observable(poDetails.POID());
    self.TimeZoneDefaultCity = ko.observable(poDetails.TimeZoneDefaultCity());
    self.SupplierPONum = ko.observable(poDetails.SupplierPONum());
    self.Destination = ko.observable(poDetails.Destination());
    self.DestinationID = ko.observable(poDetails.DestinationID());
    self.ShipmentSize = ko.observable(self.IsScheduled() ? poDetails.ShipmentSize() : "");
    self.ShipmentSizeType = ko.observable(poDetails.ShipmentSizeType());
    self.TrackingNum = ko.observable(self.IsScheduled() ? poDetails.TrackingNum() : "");
    self.MasterBillOfLading = ko.observable(self.IsScheduled() ? poDetails.MasterBillOfLading() : "");
    self.BillOfLading = ko.observable(self.IsScheduled() ? poDetails.BillOfLading() : "");
    self.CarriersReferenceNumber = ko.observable(self.IsScheduled() ? poDetails.CarriersReferenceNumber() : "");
    self.ConfirmationNumber = ko.observable(poDetails.ConfirmationNumber());
    self.OriginID = ko.observable(poDetails.OriginID());
    self.WarehouseEmail = ko.observable(poDetails.WarehouseEmail());
    self.PNCount = ko.observable(self.IsScheduled() ? poDetails.PNCount() : 0);
    self.CartonCount = ko.observable(self.IsScheduled() ? poDetails.CartonCount() : 0);
    self.NewPNCount = ko.observable(poDetails.NewPNCount());
    self.InternalPurchaseOrder = ko.observable(poDetails.InternalPurchaseOrder());
    self.PalletNum = ko.observable(self.IsScheduled() ? poDetails.PalletNum() : 0);
    self.ShippingCo = ko.observable(poDetails.ShippingCo());
    self.ContainerNum = ko.observable(poDetails.ContainerNum());
    self.IsContainer = ko.observable(self.ShipmentSize().indexOf("Container") !== -1);

    self.ScheduledDate = ko.observable(poDetails.ScheduledDate()); //
    self.DisplayInternalPurchaseOrder = ko.observable(CanDisplayInternalPurchaseOrder(poDetails.InternalPurchaseOrder()));
    self.VendorReferenceNumber = ko.observable(self.IsScheduled ? poDetails.VendorReferenceNumber() : "");
    self.IsCustomPalletCountQualified = ko.computed(() => {
        return self.ShipmentSize().indexOf('LTL') !== -1 || self.ShipmentSize().match(parcelRE) || self.InternalPurchaseOrder() !== null;
    })
    self.CanEditPalletNum = ko.computed(() => {
        return self.IsCustomPalletCountQualified() && self.ShipmentSize();
    });

    self.AllowSchedulingAfterLFD = ko.observable(poDetails.allowSchedulingAfterLFD);

    self.PalletAcknowledge = ko.observable(false);
    self.Reschedule = ko.observable(self.IsScheduled());
    self.RescheduleReason = ko.observable('');

    self.ShipmentSize.subscribe((newValue) => {
        if (!CustomPalletCountQualified()) {
            self.PalletNum(newValue.indexOf("20ft Container") !== -1 ? 13 : 26);
            self.IsContainer(newValue.indexOf("Container") !== -1);
        }
    });

    function CanDisplayInternalPurchaseOrder(internalPurchaseOrderNumber){
            return internalPurchaseOrderNumber !== null;
        };
    function CustomPalletCountQualified() {
            return self.ShipmentSize().indexOf('LTL') !== -1 || self.ShipmentSize().match(parcelRE) || self.InternalPurchaseOrder() !== null;
        };
}

var ScheduleManagerViewModel = function () {
    var self = this;
    self.submitted = ko.observable(false);

    self.stepTracker = ko.observable(0);
    self.SelectedTimeZone = ko.observable('America/Chicago');

    self.SelectedShipment = ko.observable(); //Shipment to Save

    //next button observables
    self.isPreviousVisible = ko.observable(false);
    self.isNextVisible = ko.observable(true);
    self.isFinishedVisible = ko.observable(false);

    self.nextText = ko.observable("Schedule");
    self.nextClass = ko.observable("next-action")

    //search observables
    self.poSearchText = ko.observable('');
    self.isError = ko.observable(false);
    self.possiblePOs = ko.observableArray([]);
    self.searched = ko.observable(false);
    self.isInternalPOSearch = ko.observable(false);
    self.shipmentTableClass = ko.observable("shipments");

    self.SelectedPurchaseOrder = ko.observable();
    self.newPODetailValue = ko.observable(null);

    self.activePurchaseOrderNumber = ko.observable("");
    self.activeVendorPurchaseOrderNumber = ko.observable("");
    self.activePurchaseOrderDestination = ko.observable("");

    //Select Date Range
    self.CurrentDate = ko.observable(new Date());
    self.DesiredEDD = ko.observable(null);
    self.DateSelected = ko.observable(false);

    //Select Appointment Time
    self.AvailableDates = ko.observableArray([]);
    self.NoAvailableDates = ko.observable(false);
    self.SelectedTime = ko.observable();//use SelectedTime to store chosen date AND time
    self.FirstSelectedDate = ko.observable();
    self.MyDate = ko.observable(new Date("2017-01-01"));
    self.LastSelectedDate = ko.observable();
    self.LFDRequestReason = ko.observable('');

    //Contact Info
    self.ContactInfoID = ko.observable();
    self.ContactName = ko.observable('');
    self.CarrierName = ko.observable('');
    self.Phone = ko.observable('');
    self.Email = ko.observable('');

    self.isBusy = ko.observable(false).extend({ throttle: 500 });

    self.FormatPODate = (po) => {
        const DEFAULT_TIMEZONE = 'America/Chicago';
        const APPOINTMENT_DATE_FORMAT = "MM/DD/YY, H:mm A";

        const date = po.ScheduledDate();
        const timezone = po.TimeZoneDefaultCity();

        const unformattedDate = moment
            .tz(date, DEFAULT_TIMEZONE)
            .tz(timezone);
        const formattedDate = unformattedDate.format(APPOINTMENT_DATE_FORMAT);

        return formattedDate;
    };

    //Handle selected shipment in step 1
    self.SelectedPurchaseOrder.subscribe((newValue) => {
        self.SelectedShipment(new SelectedPODetail(newValue));
    });

    // PO validity checks
    self.HasContainer = ko.computed(function () {
        return self.SelectedShipment() ? self.SelectedShipment().IsContainer() : false;
    });
    self.AllowSchedulingAfterLFD = ko.computed(function () {
        return self.SelectedShipment() ? self.SelectedShipment().AllowSchedulingAfterLFD() : false;
    });

    self.IsShipmentInfoStepComplete = ko.computed(function () {
        const po = self.SelectedShipment();
        if (!po) return false;

        if (po.PalletAcknowledge() != true) {
            return false;
        }
        if (po.CartonCount() === '' || isNaN(Number(po.CartonCount())) || Number(po.CartonCount()) <= 0) {
            return false;
        }
        if (po.PalletNum() === '' || isNaN(Number(po.PalletNum())) || Number(po.PalletNum()) <= 0) {
            return false;
        }
        if (po.VendorReferenceNumber() === "") {
            return false;
        }
        if (po.BillOfLading() === "") {
            return false;
        }

        return true;
    });

    self.IsAnySelectedPOScheduled = ko.computed(function() {
        const po = self.SelectedShipment()
        return po ? po.IsScheduled() : false;
    });

    self.IsRescheduleReasoningStepComplete = ko.computed(function () {
        const po = self.SelectedShipment();
        if (!po) return false;

        if (po.IsScheduled() && (!po.Reschedule() || po.RescheduleReason() == '')) {
            return false;
        }

        return true;;
    });

    self.POSelectStepComplete = ko.computed(function () {
        // Make sure atleast 1 PO is selected.
        if (self.SelectedShipment() == undefined || self.SelectedShipment() == null || self.SelectedShipment().length == 0) {
            return false;
        }

        // set selected PO for next steps
        self.selectPO(self.SelectedShipment());

        return true;
    });

    self.selectPO = function (po) {

        if (po.IsScheduled()) {
            po.Reschedule(true);
            self.nextText("Reschedule")
            self.nextClass("next-action-reschedule");
        } else {
            self.nextText("Schedule")
            self.nextClass("next-action");
        }

        self.SelectedTimeZone(po.TimeZoneDefaultCity());
    };

    self.searchPO = function () {
        self.possiblePOs([]);
        self.isBusy(true);
        self.EDD(); // Earliest Delivery Date
        self.searched(false);
        self.isInternalPOSearch(false);
        self.newPODetailValue(null);
        self.shipmentTableClass("shipments");
        self.nextText("Schedule");
        self.nextClass("next-action");

        self.FirstSelectedDate();
        self.LastSelectedDate();
        self.AvailableDates([]);
        self.SelectedTime();
        $("#schedule-form").steps('reset');

        $.ajax({
            type: 'GET',
            url: '/schedules/'+ self.poSearchText(),
            contentType: 'application/json',
            success: function (data) {
                self.isBusy(false);
                self.searched(true);

                if (/PO[0-9]{5}-[A-z]{2}-[0-9]{3}/.test(self.poSearchText())) {
                    self.isInternalPOSearch(true);
                    const emptyDetail = data.appointments.pop();

                    if (emptyDetail) {
                        self.newPODetailValue(new PODetail(emptyDetail));
                        self.activePurchaseOrderNumber(emptyDetail.po.internalPurchaseOrderNumber);
                        self.activeVendorPurchaseOrderNumber(emptyDetail.po.supplierPONum);
                        self.activePurchaseOrderDestination(emptyDetail.po.destination);
                        self.shipmentTableClass("purchase-order-shipments");
                    }
                }

                if (data.message !== '') {
                    self.isError(true);
                    return;
                }
                self.isError(false);

                var temp = [];
                _.each(data.appointments, function (appointment) {
                    temp.push(new PODetail(appointment));
                });

                const sortedTemp = temp.sort((a, b) => new Date(b.ScheduledDate()) - new Date(a.ScheduledDate()));
                self.possiblePOs(sortedTemp);
            },
            error: function (error) {
                console.log("Call Failed");
                self.isBusy(false);
            }
        });
    };

    self.EDD = function () {
        if ($("#js-edd-calendar").fullCalendar('getEventSources').length > 0) {
            return $("#js-edd-calendar").fullCalendar('getEventSources')[$("#js-edd-calendar").fullCalendar('getEventSources').length - 1].events[0].start;
        } else {
            return '';
        }
    }
    self.LFD = function () {
        if ($("#js-lfd-calendar").fullCalendar('getEventSources').length > 0) {
            return $("#js-lfd-calendar").fullCalendar('getEventSources')[$("#js-lfd-calendar").fullCalendar('getEventSources').length - 1].events[0].start;
        } else {
            return '';
        }
    };

    self.currentDateExtension = null;
    self.getExtendedTimes = function (data, event) {
        var request = new TimeRequest()
        request.StartDate = self.EDD().clone().utc();

        if (self.currentDateExtension === null) {
            if (self.AvailableDates() && self.AvailableDates().length > 0) {
                var lastListedDate = self.AvailableDates()[self.AvailableDates().length - 1];
                var latestDate = new moment(lastListedDate.dailyCapacity.value);
                self.currentDateExtension = latestDate.clone().add(5, 'days');
            } else {
                self.currentDateExtension = self.LFD().clone().add(5, 'days').utc();
            }

        } else {
            self.currentDateExtension = self.currentDateExtension.add(5, 'days');
        }
        request.EndDate = self.currentDateExtension.utc();


        const po = self.SelectedShipment();

        if (po) {
            request.PalletNum += parseInt(po.PalletNum());
            request.PNCount += parseInt(po.PNCount());
            request.NewPNCount += parseInt(po.NewPNCount());
            request.CartonCount += parseInt(po.CartonCount());

            if (po.ScheduledDate()) {
                po.ScheduledDate(moment(po.ScheduledDate()));
            }

            request.POs.push(new PODTO(po));
        }

        $.ajax({
            type: 'POST',
            url: '/schedules/times',
            contentType: 'application/json',
            data: JSON.stringify(request),
            success: self.handleDatesLoad,
            error: function (error) {
                console.log("Call Failed");
            }
        });
    }

    self.getAvailableTimes = function (data, event, fromCal) {
        var request = new TimeRequest()
        if (fromCal) {
            if (self.DesiredEDD() == null) {
                // if this is the first EDD that is selected, set the "Desired Delivery Date" for logging
                self.DesiredEDD(new Date(self.EDD().clone().local()));
            }
            self.FirstSelectedDate(new Date(self.EDD().clone().local()));
            request.StartDate = self.EDD().clone().utc();
        } else {
            request.StartDate = moment(self.FirstSelectedDate());
        }

        if (fromCal) {
            if (self.HasContainer() && self.LFD() > self.EDD()) {
                request.EndDate = self.LFD().clone().utc();
                self.LastSelectedDate(new Date(self.LFD().clone().local()));
            } else {
                var m = self.EDD().clone().add(10, 'days');
                request.EndDate = m.clone().utc();
                self.LastSelectedDate(new Date(m.clone().local()));
            }
        } else {
            request.EndDate = moment(self.LastSelectedDate());
        }

        const po = self.SelectedShipment();

        if (po) {
            request.PalletNum += parseInt(po.PalletNum());
            request.PNCount += parseInt(po.PNCount());
            request.NewPNCount += parseInt(po.NewPNCount());
            request.CartonCount += parseInt(po.CartonCount());
            request.POs.push(new PODTO(po));
        }

        $.ajax({
            type: 'POST',
            url: '/schedules/times',
            contentType: 'application/json',
            data: JSON.stringify(request),
            success: self.handleDatesLoad,
            error: (_) => {
                console.log("Call Failed");
            }
        });
    };

    self.handleDatesLoad = function (data) {
        var tempDates = [];
        _.each(data.availableDates, function (date) {
            var tempSlots = [];
            _.each(date.receivingCapacities, function (slot) {
                tempSlots.push({
                    value: slot.value,
                    display: moment.tz(slot.value, 'America/Chicago').tz(self.SelectedTimeZone()),
                });
            });

            if (date.dailyCapacity.display == self.EDD().format("M/D/YYYY")) {
                date.dailyCapacity.display += " - EDD";
            } else if (date.dailyCapacity.display == self.LFD().format("M/D/YYYY")) {
                date.dailyCapacity.display += " - LFD";
            }

            tempDates.push({
                dailyCapacity: date.dailyCapacity,
                receivingCapacities: tempSlots,
            });
        });

        self.AvailableDates(tempDates);
        if (self.AvailableDates()[0] !== undefined) {
            var firstListedTimeSlot = self.AvailableDates()[0].receivingCapacities[0];
            self.SelectedTime(firstListedTimeSlot);
            self.NoAvailableDates(false);
        } else {
            $.growl({ title: "", message: "No available times in this range. Adjust the selected date range and click 'More Times' or contact us for manual scheduling.", style: "error", size: "large", location: "tr" });
            self.NoAvailableDates(true);
        }
    }

    self.saveAppointment = function () {
        if (self.submitted()) {
            return;
        } else {
            self.submitted(true);
            $("#loading").removeClass("hidden");
            $(".actions ul li:nth-child(3)").addClass("disabled").attr("aria-disabled", "true");
        }

        var request = new SaveRequest(self);

        $.ajax({
            type: 'POST',
            url: '/schedules/save',
            contentType: 'application/json',
            data: JSON.stringify(request),
            success: function (result) {
                $("#loading").addClass("hidden");
                $(".actions ul li:nth-child(3)").removeClass("disabled").attr("aria-disabled", "false");

                if (result.success == false) {
                    $.growl({ title: "", message: result.errorMessage, style: "error", size: "large", location: "tr" });
                    self.submitted(false);
                    return;
                }
                self.showConfirmation();
            },
            error: function (error) {
                $.growl({ title: "", message: "Call Failed", style: "error", size: "large", location: "tr" });
                self.submitted(false);

                $("#loading").addClass("hidden");
                $(".actions ul li:nth-child(3)").removeClass("disabled").attr("aria-disabled", "false");
            }
        });

    };

    self.submitRequestForApproval = function (poid, email, requestReason) {
        var request = new ScheduleAfterLFDRequest();
        request.POID = poid;
        request.Email = email;
        request.RequestReason = requestReason;

        var re = /.*@.+\..+/i;
        var match = self.Email().match(re);
        if (!match) {
            $.growl({ title: "", message: "Please Enter a Valid Email", style: "error", size: "large", location: "tr" });
            return false;
        }

        $.ajax({
            type: 'POST',
            url: '/Schedule/RequestApprovalToScheduleAfterLFD',
            contentType: 'application/json',
            data: JSON.stringify(request),
            success: function (result) {
                self.showConfirmationOfRequestToScheduleAfterLFD();
            },
            error: function (error) {
                alert('Unable to submit your request. Please contact us for help.');
            }
        });
    };

    self.showConfirmation = function () {
        $.ajax({
            type: 'GET',
            url: '/schedules/confirmation',
            contentType: 'application/json',
            data: "",
            success: function (response) {
                if (response.result == "Redirect") {
                    window.location = response.url;
                }
            }
        });
    }

    self.showConfirmationOfRequestToScheduleAfterLFD = function (confirmationNumber) {
        $.ajax({
            type: 'GET',
            url: '/schedules/lfd-confirmation',
            contentType: 'application/json',
            data: "",
            success: function (response) {
                if (response.result == "Redirect") {
                    window.location = response.url;
                }
            }
        });
    }
    amplify.subscribe('date-picked', function () {
        self.DateSelected(true);
    });

    amplify.subscribe('date-not-picked', function () {
        self.DateSelected(false);
    });

    // next button state handling
    self.validForm = ko.computed(function () {
        const currentStep = self.stepTracker();

        switch (currentStep) {
            case SectionIndex.search:
                return self.POSelectStepComplete();
            case SectionIndex.rescheduleReasoning:
                return self.IsRescheduleReasoningStepComplete();
            case SectionIndex.shipmentInfo:
                return self.IsShipmentInfoStepComplete();
            case SectionIndex.earliestDeliveryDate:
                if (!self.DateSelected() || self.EDD() == '') { return false; }
                break;
            case SectionIndex.lastFreeDate:
                if (self.HasContainer() && (!self.DateSelected() || self.LFD() == '')) { return false; }
                break;
            case SectionIndex.appointmentTime:
                if (self.AvailableDates().length < 1) { return false; }
                var match = _.find(self.AvailableDates(), function (date) {
                    var any = _.find(date.receivingCapacities, function (time) {
                        return self.SelectedTime() && time.value == self.SelectedTime().value;
                    });
                    return any != null && any != undefined;
                });
                if (match == null || match == undefined) { return false; }
                break;
            case SectionIndex.contactInfo:
                if (self.ContactName() == '' || self.CarrierName() == '' || self.Phone() == '') { return false; }
                var pRE = /\+?\d?[-\s]*\(?\d\d\d\)?[-\s]*\d\d\d[-\s]*\d\d\d\d/;
                var phoneMatch = self.Phone().match(pRE);
                if (!phoneMatch || phoneMatch.index != 0) { return false; }
                var eRE = /.*@.+\..+/i;
                var match = self.Email().match(eRE);
                if (!match) { return false; }
                break;
            default:
                return true;
        }
        return true;
    });

    self.ForceSkipSteps = (priorIndex, currentIndex, { nextStep, previousStep }) => {

        if (currentIndex == SectionIndex.rescheduleReasoning && !self.IsAnySelectedPOScheduled()) {
            if (priorIndex > SectionIndex.rescheduleReasoning) {
                previousStep();
                return;
            } else {
                nextStep();
                return;
            }
        }

        //only allow containers to enter LFD
        if (currentIndex === SectionIndex.lastFreeDate && !self.HasContainer()) {
            if (priorIndex === SectionIndex.appointmentTime) {
                previousStep();
                return;
            } else {
                nextStep();
                return;
            }
        }
    }

    self.validForm.subscribe(function () {
        if (self.validForm()) {
            enableNext();
        } else {
            disableNext();
        }
    });

    // form wizard
    var form = $("#schedule-form").show();
    form.steps({
        headerTag: "h3",
        bodyTag: "section",
        transitionEffect: "fade",
        autoFocus: true,
        enableKeyNavigation: true,
        enablePagination: false,
        onStepChanging: function (event, currentIndex, newIndex) {

            // Allways allow previous action even if the current form is not valid
            if (currentIndex > newIndex) {
                return true;
            }

            // Everything below, the step is changing to the NEXT step

            if (newIndex === SectionIndex.search) {
                $('#poSearch').focus();
            }

            if (currentIndex === SectionIndex.search) {
                if (!self.POSelectStepComplete()) {
                    $.growl({ title: "", message: "Please select a shipment before continuing", style: "error", size: "large", location: "tr" });
                    return false;
                }

                self.nextText("Next");
                self.isPreviousVisible(true);
                self.nextClass("next-action");
            }


            if (currentIndex == SectionIndex.rescheduleReasoning) {
                if (!self.IsRescheduleReasoningStepComplete()) {
                    $.growl({
                        title: "",
                        message: "Please enter a reason for rescheduling.",
                        style: "error",
                        size: "large",
                        location: "tr"
                    });

                    return false;
                }
            }

            if (currentIndex == SectionIndex.shipmentInfo) {
                if (!self.IsShipmentInfoStepComplete()) {
                    $.growl({
                        title: "",
                        message: "Please enter required information and acknowledge the information entered is accurate.",
                        style: "error",
                        size: "large",
                        location: "tr"
                    });

                    return false;
                }
            }

            //get times based on PO and EDD info so far
            if (newIndex === SectionIndex.lastFreeDate && currentIndex === SectionIndex.earliestDeliveryDate) {
                if (!self.DateSelected()) {
                    $.growl({ title: "", message: "Please Select a Date", style: "error", size: "large", location: "tr" });
                    return false;
                }

                if (!self.HasContainer()) {
                    self.getAvailableTimes(null, null, true);
                }
            }

            if (self.HasContainer() && newIndex === SectionIndex.appointmentTime && currentIndex === SectionIndex.lastFreeDate) {
                if (!self.DateSelected()) {
                    $.growl({ title: "", message: "Please Select a Date", style: "error", size: "large", location: "tr" });
                    return false;
                }

                // reset date extension for "Load More Times" on fresh date load
                self.currentDateExtension = null;

                self.getAvailableTimes(null, null, true);
            }

            // check if they have selected a valid time, if not prevent them from moving on.
            if (currentIndex == SectionIndex.appointmentTime) {
                if (self.AvailableDates().length < 1) {
                    $.growl({ title: "", message: "Please Select New Date Range and Click More Times for Available Receiving Times", style: "error", size: "large", location: "tr" });
                    return false;
                }
                var match = _.find(self.AvailableDates(), function (date) {
                    var any = _.find(date.receivingCapacities, function (time) {
                        return self.SelectedTime() && time.value == self.SelectedTime().value;
                    });
                    return any != null && any != undefined;
                });

                if (match == null || match == undefined) {
                    $.growl({ title: "", message: "Please Select an Available Time Slot for Receiving", style: "error", size: "large", location: "tr" });
                    return false;
                }
            }

            //force selected time formatted strings to update
            if (currentIndex === SectionIndex.contactInfo) {
                var pRE = /\+?\d?[-\s]*\(?\d\d\d\)?[-\s]*\d\d\d[-\s]*\d\d\d\d/;
                var phoneMatch = self.Phone().match(pRE);
                if (!phoneMatch || phoneMatch.index != 0) {
                    $.growl({ title: "", message: "Please Enter a Valid Phone Number", style: "error", size: "large", location: "tr" });
                    return false;
                }
                var re = /.*@.+\..+/i;
                var match = self.Email().match(re);
                if (!match) {
                    $.growl({ title: "", message: "Please Enter a Valid Email", style: "error", size: "large", location: "tr" });
                    return false;
                }

                self.isNextVisible(false);
                self.isFinishedVisible(true);
            }

            form.validate().settings.ignore = ":disabled,:hidden";
            return form.valid();
        },
        onStepChanged: function (event, currentIndex, priorIndex) {

            // Used to force skip steps (could alter this and put it in onStepChanging to clean up the animation)
            self.ForceSkipSteps(
                priorIndex,
                currentIndex,
                {
                    nextStep: () => $(this).steps("next"),
                    previousStep: () => $(this).steps("previous"),
                });

            if (currentIndex === SectionIndex.earliestDeliveryDate) {
                $('#js-edd-calendar').fullCalendar('render');
                if (self.EDD() == '') {
                    amplify.publish('date-not-picked');
                }
            }

            if (currentIndex === SectionIndex.lastFreeDate) {
                $('#js-lfd-calendar').fullCalendar('render');
                if (self.LFD() == '') {
                    amplify.publish('date-not-picked');
                }
            }

            self.stepTracker(currentIndex);
        },
        onFinishing: function (event, currentIndex) {
            form.validate().settings.ignore = ":disabled";
            return form.valid();
        },
        onFinished: function (event, currentIndex) {
            self.saveAppointment();
        }
    });
    $('#poSearch').focus();


    $.fn.steps.reset = function () {
        //These private methods aren't working so it's hardcoded for now
        //See https://searchcode.com/codesearch/view/100050605/ for original methods
        var wizard = this,
        //options = getOptions(this),
        options = wizard.data("options"),
        //state = getState(this);
        state = wizard.data("state");
        //goToStep(wizard, options, state, 0);

        for (var i = 1; i < state.stepCount; i++) {
            //var stepAnchor = getStepAnchor(wizard, i);
            var uniqueId = getUniqueId(wizard);
            var _tabSuffix = "-t-";
            var stepAnchor = wizard.find("#" + uniqueId + _tabSuffix + i);
            stepAnchor.parent().removeClass("done")._enableAria(false);
        }
    };

    function disableNext() {
        $(".actions ul li:nth-child(2)").addClass("disabled").attr("aria-disabled", "true");
    };

    function enableNext() {
        $(".actions ul li:nth-child(2)").removeClass("disabled").attr("aria-disabled", "false");
    };

    function getUniqueId(wizard) {
        var uniqueId = wizard.data("uid");

        if (uniqueId == null) {
            uniqueId = wizard._id();
            if (uniqueId == null) {
                uniqueId = "steps-uid-".concat(_uniqueId);
                wizard._id(uniqueId);
            }

            _uniqueId++;
            wizard.data("uid", uniqueId);
        }

        return uniqueId;
    }
};

var ContactInfo = function (vm) {
    var self = this;
    self.ContactInfoID = vm.ContactInfoID();
    self.ContactName = vm.ContactName();
    self.CarrierName = vm.CarrierName();
    self.Phone = vm.Phone();
    self.Email = vm.Email();
};

var WarehouseDTO = function (po) {
    var self = this;
    self.OriginID = po.OriginID();
    self.Email = po.WarehouseEmail();
}

var SaveRequest = function (vm) {
    var self = this;
    self.Appointment = new AppointmentDTO(vm, vm.SelectedShipment());
}

var PODTO = function (po) {
    var self = this;
    self.POID = po.POID();
    self.SupplierPONum = po.SupplierPONum();
    self.ContainerNum = po.ContainerNum();
    self.TrackingNum = po.TrackingNum();
    self.OriginID = po.OriginID();
    self.Destination = po.Destination();
    self.DestinationID = po.DestinationID();
    self.ShipmentSize = po.ShipmentSize();
    self.ShipmentSizeType = po.ShipmentSizeType();
    self.CartonCount = po.CartonCount();
    self.PNCount = po.PNCount();
    self.NewPNCount = po.NewPNCount();
    self.IsScheduled = po.IsScheduled();
    self.ScheduledDate = po.ScheduledDate();
    self.InternalPurchaseOrderNumber = po.InternalPurchaseOrder();
}

var AppointmentDTO = function (vm, po) {
    var self = this;
    self.AppointmentId = po.AppointmentId();
    self.PO = new PODTO(po);
    self.Warehouse = new WarehouseDTO(po);
    self.Contact = new ContactInfo(vm);
    self.ConfirmationNumber = po.ConfirmationNumber();
    self.PurchaseOrderNumber = po.InternalPurchaseOrder();
    self.IsReschedule = po.Reschedule();
    self.RescheduleReason = po.RescheduleReason();
    self.WarehouseID = po.DestinationID();
    self.ShipmentSize = po.ShipmentSize();
    self.PalletCount = po.PalletNum();
    self.CartonCount = po.CartonCount();
    self.PNCount = po.PNCount();
    self.NewPNCount = po.NewPNCount();
    self.VendorReferenceNumber = po.VendorReferenceNumber();
    self.TrackingNumber = po.TrackingNum();
    self.CarrierProNumber = po.CarriersReferenceNumber();
    self.BillOfLadingNumber = po.BillOfLading();
    self.MasterBillOfLadingNumber = po.MasterBillOfLading();

    self.AppointmentDate = vm.SelectedTime().value;
    self.DesiredEarliestDeliveryDate = vm.DesiredEDD();
    self.EarliestDeliveryDate = vm.EDD();
    self.LastFreeDate = vm.LFD();

    self.SchedulerName = vm.ContactName();
    self.ConfirmationEmailAddress = vm.Email();
    self.ContactPhone = vm.Phone();
};

var TimeRequest = function () {
    var self = this;
    self.StartDate = '';
    self.EndDate = '';
    self.PalletNum = 0;
    self.PNCount = 0;
    self.NewPNCount = 0;
    self.CartonCount = 0;
    self.POs = [];
}

var ScheduleAfterLFDRequest = function () {
    var self = this;
    self.Email = '';
    self.RequestReason = '';
    self.POID = 0;
}

var ScheduleAfterLFDRequest = function () {
    var self = this;
    self.Email = '';
    self.RequestReason = '';
    self.POID = 0;
}

ko.bindingHandlers.datepicker = {
    init: function (element, valueAccessor, allBindingsAccessor) {
        var $el = $(element);

        //initialize datepicker with some optional options
        var options = allBindingsAccessor().datepickerOptions || {};
        $el.datepicker(options);

        //handle the field changing
        ko.utils.registerEventHandler(element, "change", function () {
            var observable = valueAccessor();
            observable($el.datepicker("getDate"));
        });

        //handle disposal (if KO removes by the template binding)
        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            $el.datepicker("destroy");
        });

    },
    update: function (element, valueAccessor, allBindingsAccessor) {
        var value = ko.utils.unwrapObservable(valueAccessor()),
            options = allBindingsAccessor().datepickerOptions || {},
            $el = $(element),
            current = $el.datepicker("getDate");

        $el.datepicker("option", "minDate", options.minDate);

        if (value - current !== 0) {
            $el.datepicker("setDate", value);
        }
    }
};

ko.bindingHandlers.dateRangePicker = {
    init: function (element, valueAccessor, allBindingsAccessor) {
        var options = allBindingsAccessor().dateTimePickerOptions || {
            format: "MM/DD/YYYY",
            inline: false
        };
        $(element).datetimepicker(options);

        //when a user changes the date, update the view model
        ko.utils.registerEventHandler(element, "dp.change", function (event) {
            var value = valueAccessor();
            if (ko.isObservable(value)) {
                if (event.date != null && !(event.date instanceof Date)) {
                    value(event.date.toDate());
                } else {
                    value(event.date);
                }
            }
        });

        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            var picker = $(element).data("DateTimePicker");
            if (picker) {
                picker.destroy();
            }
        });
    },
    update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {

        var picker = $(element).data("DateTimePicker");
        //when the view model is updated, update the widget
        if (picker) {
            var koDate = ko.utils.unwrapObservable(valueAccessor());

            //in case return from server datetime is in this form /Date(93989393)/ then fomat it here
            koDate = (typeof (koDate) !== 'object') ? new Date(parseFloat(koDate.replace(/[^0-9]/g, ''))) : koDate;

            picker.date(koDate);
        }
    }
};

ko.bindingHandlers.inlineDateTimePicker = {
    init: function (element, valueAccessor, allBindingsAccessor) {
        var options = allBindingsAccessor().dateTimePickerOptions || {
            format: "MM/DD/YYYY",
            inline: true
        };
        $(element).datetimepicker(options);

        //when a user changes the date, update the view model
        ko.utils.registerEventHandler(element, "dp.change", function (event) {
            var value = valueAccessor();
            if (ko.isObservable(value)) {
                if (event.date != null && !(event.date instanceof Date)) {
                    value(event.date.toDate());
                } else {
                    value(event.date);
                }
            }
        });

        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            var picker = $(element).data("DateTimePicker");
            if (picker) {
                picker.destroy();
            }
        });
    },
    update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {

        var picker = $(element).data("DateTimePicker");
        //when the view model is updated, update the widget
        if (picker) {
            var koDate = ko.utils.unwrapObservable(valueAccessor());

            //if return from server datetime is in this form /Date(93989393)/ then fomat it here
            koDate = (typeof (koDate) !== 'object') ? new Date(parseFloat(koDate.replace(/[^0-9]/g, ''))) : koDate;

            picker.date(koDate);
        }
    }
};

//Allows observable updating without notifying subscribers
//I took the usage out but it still looks useful in general
//use ko.observable(initialValue).withPausing() for the observable declaration and call with observableName.sneakyUpdate(newValue)
ko.observable.fn.withPausing = function () {
    this.notifySubscribers = function () {
        if (!this.pauseNotifications) {
            ko.subscribable.fn.notifySubscribers.apply(this, arguments);
        }
    };

    this.sneakyUpdate = function (newValue) {
        this.pauseNotifications = true;
        this(newValue);
        this.pauseNotifications = false;
    };

    return this;
};

$(document).ready(function () {
    $('[data-toggle="tooltip"]').tooltip()
    var myScheduleManagerViewModel = new ScheduleManagerViewModel();
    var getScheduledDateData = function(start) {
        var errorMessage = "All shipments must be scheduled prior to 2:30pm EST the day before the requested shipment";
        var currentEST = moment().tz("America/New_York");
        var currentESTDay = currentEST.isoWeekday();
        var currentESTHour = parseInt(currentEST.hours(), 10);
        var currentESTMinutes = parseInt(currentEST.minutes(), 10);
        var daysToAdd = 1;

        // If it's currently a Friday after 3pm EST, Saturday or Sunday
        if ((currentESTDay === 5 && currentESTHour >= 14 && currentESTMinutes >= 30) || currentESTDay === 6 || currentESTDay === 7) {
            var nextTuesday = moment().add(1, 'weeks').isoWeekday(2);
            daysToAdd = nextTuesday.diff(currentEST, 'days');

            // If scheduling for Monday show more relevant error message
            if (start.isoWeekday() === 1) {
                errorMessage = "All shipments must be scheduled prior to 2:30pm EST Friday for Monday shipments";
            }
        } else if (currentESTHour >= 14 && currentESTMinutes >= 30) { // If the time is later than 2:30pm eastern time
            daysToAdd = 2;
        }

        var isValidDate = start >= moment().utc().add(daysToAdd, 'days').startOf('day');

        return {
            isValid: isValidDate,
            errorMessage: !isValidDate && errorMessage
        };
    };

    var showInvalidErrorMessage = function(errorMessage) {
        $.growl({ title: "", message: errorMessage, style: "error", size: "large", location: "tr" });
    };

    $('#js-edd-calendar').fullCalendar({
        height: 'auto',
        selectable: true,
        select: function (start, end, jsEvent, view) {
            var scheduledDate = getScheduledDateData(start);
            $("#js-edd-calendar").fullCalendar('removeEvents');

            if (scheduledDate.isValid) {
                $("#js-edd-calendar").fullCalendar('addEventSource', [{
                    start: start,
                    end: end,
                    rendering: 'background',
                    block: true
                }]);
                amplify.publish('date-picked');
            } else {
                showInvalidErrorMessage(scheduledDate.errorMessage);
                $("#js-edd-calendar").fullCalendar("unselect");
                amplify.publish('date-not-picked');
            }
        },
        selectOverlap: function (event) {
            return true;
        },
        selectConstraint: {
            start: '00:00',
            end: '24:00'
        },
        header: {
            left: '',
            center: 'title',
            right: 'today prev,next'
        },
        fixedWeekCount: false
    });

    $('#js-lfd-calendar').fullCalendar({
        height: 'auto',
        selectable: true,
        select: function (start, end, jsEvent, view) {
            $("#js-lfd-calendar").fullCalendar('removeEvents');
            $("#js-lfd-calendar").fullCalendar('addEventSource', [{
                start: start,
                end: end,
                rendering: 'background',
                block: true,
            }]);
            amplify.publish('date-picked');
        },
        selectOverlap: function (event) {
            return true;
        },
        selectConstraint: {
            start: '00:00',
            end: '24:00'
        },
        header: {
            left: '',
            center: 'title',
            right: 'today prev,next'
        },
        fixedWeekCount: false
    });

    const nextButton = document.getElementById("next-action");
    const prevButton = document.getElementById("previous-action");
    const finishButton = document.getElementById("finished-action");

    nextButton.addEventListener("click", () => {
        $("#schedule-form").steps("next");
    });

    prevButton.addEventListener("click", () => {
        $("#schedule-form").steps("previous");
    });

    finishButton.addEventListener("click", () => {
        $("#schedule-form").steps("finish");
    });

    ko.applyBindings(myScheduleManagerViewModel);
});

